import { useEffect, useState } from 'react';
import TicketProfileCard from './TicketProfileCard';
import Msg from "../../../components/Msg";
import { useTranslation } from 'react-i18next';
import { FollowUpService } from '../../../services/FollowUpService';
import { useCurrentAccount } from '../../../hooks/useCurrentAccount';
import Select from 'react-select';
import useRequest from '../../../hooks/useRequest';
import Loader from '../../../components/Loader';
import { SubAccountService } from '../../../services/SubaccountService';

export default function SideBar({ selectedInterval, onFiltersChange, totalTickets }) {
    const { t } = useTranslation();
    const { account } = useCurrentAccount();
    const { call, isRequesting } = useRequest();
    const [tickets, setTickets] = useState([]);
    const [search, setSearch] = useState('');
    const [newTickets, setNewTickets] = useState([]);
    const [checkboxStates, setCheckboxStates] = useState({ tsra: false, tsrc: false });
    const [activeFilters, setActiveFilters] = useState({ tsra: false, tsrc: false });
    const [subAccounts, setSubAccounts] = useState([]);
    const [selectedSubAccount, setSelectedSubAccount] = useState([]);
    const [filterApply, setFilterApply] = useState(false)
    const [totalFilter, setTotalFilter] = useState(0)
    const [selectedBase, setSelectedBase] = useState(null);
    const [selectedLabel, setSelectedLabel] = useState(null);

    const getTickets = async () => {
        const { data } = await call(() => FollowUpService.getOpenTickets(account.id));
        setTickets(data);
    };
    const getSubAccounts = async () => {
        const { data } = await SubAccountService.getSubaccounts(account.id);
        setSubAccounts(data.sub_accounts.map(subAccount => ({
            value: subAccount.id,
            label: subAccount.name
        })));
    };
    useEffect(() => {
        getTickets();
        getSubAccounts();
    }, [t]);

    useEffect(() => {
        const interval = setInterval(() => {
            getTickets();
        }, selectedInterval.value * 60 * 1000);

        return () => clearInterval(interval);
    }, [selectedInterval]);

    useEffect(() => {
        applyFilters();
    }, [tickets, search]);

    useEffect(() => {
        const handleUpdateTickets = () => {
            getTickets();
        };
        window.addEventListener('updateTickets', handleUpdateTickets);
        return () => {
            window.removeEventListener('updateTickets', handleUpdateTickets);
        };
    }, []);

    const apply = () => {
        const updatedFilters = { tsra: checkboxStates.tsra, tsrc: checkboxStates.tsrc };
        setActiveFilters(updatedFilters);
        onFiltersChange(updatedFilters, selectedSubAccount);
        applyFilters();
    };

    const applyFilters = () => {
        if (checkboxStates.tsra || checkboxStates.tsrc || selectedSubAccount.length > 0 || selectedBase?.length > 0 || selectedLabel?.length > 0) {
            setFilterApply(true);
        } else {
            setFilterApply(false);
        }
        let filteredTickets = tickets.filter(ticket => {
            if (checkboxStates.tsra && checkboxStates.tsrc) {
                return true;
            }else if (selectedSubAccount.length > 0) {
                return selectedSubAccount.filter(subAccount => subAccount.label === ticket.sub_account).length > 0;
            }else if(selectedBase?.length > 0){
                return selectedBase.filter(base => base.value === ticket.base_name).length > 0;
            }else if (selectedLabel?.length > 0){
                return selectedLabel.filter(label => label.value === ticket.label_ticket).length > 0;
            } else if (checkboxStates.tsra) {
                return ticket._status_ticket === 'tsra';
            } else if (checkboxStates.tsrc) {
                return ticket._status_ticket === 'tsrc';
            }
            return true;
        });

        setTotalFilter(filteredTickets.length)

        filteredTickets = filteredTickets.filter(ticket =>
            (ticket?.name_client && ticket.name_client.toLowerCase().includes(search.toLowerCase())) ||
            (ticket?.chat_number && ticket.chat_number.toLowerCase().includes(search.toLowerCase())) ||
            (ticket?.assing_to && ticket.assing_to.toLowerCase().includes(search.toLowerCase())) ||
            (ticket?._status_ticket && ticket._status_ticket.toLowerCase().includes(search.toLowerCase())) ||
            (ticket?.sub_account && ticket.sub_account.toLowerCase().includes(search.toLowerCase())) ||
            (ticket?.label_ticket && ticket.label_ticket.toLowerCase().includes(search.toLowerCase())) ||
            (ticket?.base_name && ticket.base_name.toLowerCase().includes(search.toLowerCase()))
        );
        
        setNewTickets(filteredTickets);
    };
        

    const baseOptions = [...new Set(tickets.map(ticket => ticket.base_name).filter(base => base !== null && base !== undefined && base !== '')
    )].map(base => ({
        value: base,
        label: base
    }));    
      
    const labelOptions = [...new Set(tickets.map(ticket => ticket.label_ticket))].filter(label => label !== null && label !== undefined && label !== '' ).map(label => ({ value: label, label: label }));
    const verifyFilters = () => {
        setCheckboxStates({
            tsra: activeFilters.tsra,
            tsrc: activeFilters.tsrc,
        });
    };


    const changetsraHandler = () => {
        setCheckboxStates({
            ...checkboxStates,
            tsra: !checkboxStates.tsra
        });
    };
    const changetsrcHandler = () => {
        setCheckboxStates({
            ...checkboxStates,
            tsrc: !checkboxStates.tsrc
        });
    };

    const handleClearFilters = (event) => {
        event.stopPropagation();
        setActiveFilters({ tsra: false, tsrc: false });
        setCheckboxStates({ tsra: false, tsrc: false });
        setSelectedBase(null);
        setSelectedLabel(null);
        setNewTickets([...tickets]);
        setSelectedSubAccount([]);
        setFilterApply(false);
    };

    const handleSelectChange = (selectedOptions) => {
        const updatedSubAccount = selectedOptions || [];
        setSelectedSubAccount(updatedSubAccount);
        onFiltersChange(activeFilters, updatedSubAccount);
    };

    return (
        <>
            <div className='col-3 border border-end-0 p-0'>
                <div className="d-flex m-0 border-bottom px-3 py-21 mb-3">
                    <div className=" input-group input-group-merge p-0 me-2">
                        <div className="input-group-prepend input-group-text">
                            <i className="bi-search"></i>
                        </div>
                        <input
                            type="search"
                            className="form-control h-34 font-12"
                            placeholder={t("components.custom-table.filter")}
                            onChange={({ target: { value } }) => setSearch(value)}
                            value={search}
                        />
                    </div>
                    <div className="dropdown">
                        <button
                            type="button"
                            className={`btn btn-white btn-sm w-100 text-nowrap fw-bolder`}
                            id="usersFilterDropdown"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                            onClick={verifyFilters}
                        >
                            <i className="bi-ui-radios me-1"></i> {t("follow-up.sidebar.filter-btn")}
                        </button>
                        <div className="dropdown-menu dropdown-menu-sm-end dropdown-card card-dropdown-filter-centered" aria-labelledby="usersFilterDropdown" style={{ minWidth: "20rem" }}>
                            <div className="card">
                                <div className="card-header card-header-content-between">
                                    <h5 className="card-header-title">{t("follow-up.sidebar.filter-dropdown-title")}</h5>
                                    <button title="button" type="button" className="btn btn-ghost-secondary btn-icon btn-sm ms-2">
                                        <i className="bi-x-lg"></i>
                                    </button>
                                </div>
                                <div className="card-body">
                                    <div className="mb-4">
                                        <small className="text-cap text-body">{t("follow-up.sidebar.filter-dropdown_t1")}</small>
                                        <div className="row">
                                            <div className="col">
                                                <div className="form-check">
                                                    <input title="input" className="form-check-input" type="checkbox" value="" id="tsra" onChange={changetsraHandler} checked={checkboxStates.tsra} />
                                                    <label className="form-check-label text-nowrap" htmlFor="usersFilterCheckAll">
                                                        {t("follow-up.sidebar.filter-dropdown_ta")}
                                                    </label>
                                                </div>
                                            </div>
                                            <div className="col">
                                                <div className="form-check">
                                                    <input title="input" className="form-check-input" type="checkbox" value="" id="tsrc" onChange={changetsrcHandler} checked={checkboxStates.tsrc} />
                                                    <label className="form-check-label text-nowrap" htmlFor="usersFilterCheckEmployee">
                                                        {t("follow-up.sidebar.filter-dropdown_tc")}
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="mb-4">
                                        <small className="text-cap text-body">{t("follow-up.sidebar.filter-dropdown_ASubaccount")}</small>
                                        <div className="row" onClick={(e) => e.stopPropagation()}>
                                            <div className="col">
                                                <Select
                                                    isMulti
                                                    options={subAccounts}
                                                    value={selectedSubAccount}
                                                    onChange={handleSelectChange}
                                                    placeholder={t("follow-up.sidebar.filter-dropdown_ASubaccountPh")}
                                                    className={'tom-select-custom tom-select-custom-with-tags'}
                                                    classNamePrefix='form-select-custom'
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="mb-4">
                                        <small className="text-cap text-body">{t("follow-up.sidebar.filter-dropdown_ALabels")}</small>
                                        <div className="row" onClick={(e) => e.stopPropagation()}>
                                            <div className="col">
                                                <Select
                                                    isMulti
                                                    options={labelOptions}
                                                    value={selectedLabel}
                                                    onChange={setSelectedLabel}
                                                    placeholder={t("follow-up.sidebar.filter-dropdown_ALabelsPh")}
                                                    className={'tom-select-custom tom-select-custom-with-tags'}
                                                    classNamePrefix='form-select-custom'
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="mb-4">
                                        <small className="text-cap text-body">{t("follow-up.sidebar.filter-dropdown_ABases")}</small>
                                        <div className="row" onClick={(e) => e.stopPropagation()}>
                                            <div className="col">
                                                <Select
                                                    isMulti
                                                    options={baseOptions}
                                                    value={selectedBase}
                                                    onChange={setSelectedBase}
                                                    placeholder={t("follow-up.sidebar.filter-dropdown_ABasesPh")}
                                                    className={'tom-select-custom tom-select-custom-with-tags'}
                                                    classNamePrefix='form-select-custom'
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="d-grid">
                                        <a className="text-cap btn btn-link text-danger text-nowrap" onClick={handleClearFilters} style={{ fontSize: '10px', marginLeft: '60%' }}>{t("follow-up.sidebar.filter-dropdown_clearF")}</a>
                                        <a className="btn btn-primary" onClick={apply}>{t("follow-up.sidebar.filter-dropdown_aply")}</a>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                {filterApply && (
                    <div className="row mb-5">
                        <div className="d-flex justify-content-start ms-3 mb-1">
                            <span className="text-success fs-4 fw-bolder">
                                <i className="bi-ui-radios me-1"></i> Filtros activos
                            </span>
                        </div>
                        <p className="fw-bolder text-light-success fs-6 ms-3">
                            {totalFilter} de {totalTickets} Tickets filtrados
                        </p>
                    </div>
                )}
                <div className='overflow-scroll sidebar relative'>
                    {
                        isRequesting ? <Loader /> :
                            newTickets.length > 0 ?
                                newTickets.map(d => <TicketProfileCard data={d} key={d.account_key_client} />) : <Msg />}
                </div>
            </div>
        </>
    );
}
